module.exports = __webpack_public_path__ + "img/screen-users.44c540ae.svg";